import { render, staticRenderFns } from "./NewResearch.vue?vue&type=template&id=c5e20f50"
import script from "./NewResearch.vue?vue&type=script&lang=js"
export * from "./NewResearch.vue?vue&type=script&lang=js"
import style0 from "./NewResearch.vue?vue&type=style&index=0&id=c5e20f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports